import { render, staticRenderFns } from "./zoon-info.vue?vue&type=template&id=5b59e32c&scoped=true&"
import script from "./zoon-info.vue?vue&type=script&lang=js&"
export * from "./zoon-info.vue?vue&type=script&lang=js&"
import style0 from "./zoon-info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./zoon-info.vue?vue&type=style&index=1&id=5b59e32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59e32c",
  null
  
)

export default component.exports